import React from "react";
import {DetailPanel} from "../../../components/detailLayout";
import {SimmsRadio} from "../../../components/input/SimmsRadio";
import SimmsInput from "../../../components/input/SimmsInput";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import {checkResult} from "./DailyCheckReportCreate";
import "../../maintenance/inspection/report/inspectionReportMatrix.css";
import "./dailyCheckReportItems.css";

export function normalizeDailyCheckItem(item, mode = "view") {
    if (mode === "create") {
        return {
            name: item.name,
            confirm: item.confirm,
            standard: item.standard,
            result: item.result,
            reportEtc: item.reportEtc,
        };
    }

    return {
        name: item.dailyCheckField?.name,
        confirm: item.dailyCheckField?.confirm,
        standard: item.dailyCheckField?.standard,
        result: item.result,
        reportEtc: item.reportEtc,
    };
}

function DailyCheckReportItemsPanel({
    title = "체크항목",
    list = [],
    mode = "view",
    readOnly = false,
    editable = false,
    onInputChange,
    emptyMessage = "[일일체크]를 선택해주세요.",
}) {
    const rows = list.map((item) => normalizeDailyCheckItem(item, mode));
    const filledCount = rows.filter((row) => row.result != null && row.result !== "").length;

    return (
        <DetailPanel title={title} className="inspection-report-section-panel daily-check-items-panel">
            {rows.length > 0 ? (
                <>
                    <div className="ir-section-toolbar">
                        <div className="ir-section-toolbar__left">
                            <span className="ir-section-stat">
                                <strong>{rows.length}</strong> 체크항목
                            </span>
                            <span className="ir-section-stat ir-section-stat--progress">
                                입력 <strong>{filledCount}/{rows.length}</strong>
                            </span>
                        </div>
                    </div>

                    <div className="ir-group-inline-form daily-check-items-panel__table-wrap">
                        <table className="w-full daily-check-items-table">
                            <thead>
                            <tr>
                                <th className="fieldset-th">체크항목</th>
                                <th className="fieldset-th">체크방법</th>
                                <th className="fieldset-th">기준 &amp; 권장값</th>
                                <th className="fieldset-th">체크결과</th>
                                <th className="fieldset-th">기타</th>
                            </tr>
                            </thead>
                            <tbody>
                            {rows.map((row, index) => (
                                <tr key={index}>
                                    <th className="fieldset-th">
                                        <span className="ir-item-inline-form__name">{row.name}</span>
                                    </th>
                                    <td className="fieldset-td daily-check-items-table__text">{row.confirm}</td>
                                    <td className="fieldset-td daily-check-items-table__text">{row.standard}</td>
                                    <td className="fieldset-td">
                                        {readOnly ? (
                                            checkResult
                                                .filter((item) => item.value === row.result)
                                                .map((item) => (
                                                    <span key={item.value} className="daily-check-items-table__result">
                                                        {item.text}
                                                    </span>
                                                ))
                                        ) : (
                                            <SimmsRadio
                                                options={checkResult}
                                                onChange={(v) => onInputChange?.(v, index, "result")}
                                                data={row.result}
                                                title={`daily_check_result_${index}`}
                                                auth={editable}
                                            />
                                        )}
                                    </td>
                                    <td className="fieldset-td">
                                        {readOnly ? (
                                            <ReadOnlyInputBasic target="reportEtc" value={row.reportEtc}/>
                                        ) : (
                                            <SimmsInput
                                                onChange={(v) => onInputChange?.(v, index, "reportEtc")}
                                                data={row.reportEtc}
                                                auth={editable}
                                            />
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                <div className="daily-check-items-empty">{emptyMessage}</div>
            )}
        </DetailPanel>
    );
}

export default DailyCheckReportItemsPanel;
